// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify'
import { sync } from 'vuex-router-sync'
import store from './store/store.js'
import VueYouTubeEmbed from 'vue-youtube-embed'
import Panel from './components/globals/Panel.vue'
import 'vuetify/dist/vuetify.min.css'
import VueResizeText from 'vue-resize-text'

Vue.config.productionTip = false

Vue.use(Vuetify)
Vue.use(VueYouTubeEmbed)

Vue.component('panel', Panel)

Vue.use(VueResizeText)

sync(store, router)

Vue.mixin({
  data: function () {
    return {
      get portalVersion () {
        return '01.06.00.00'
      }
    }
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})
